import { Outlet } from "react-router-dom"
export default function AdminLayout() {
  return (
    <div className="flex min-h-screen">
      {/* <AdminSidebar /> */}
      <div className="flex-1">
        {/* <AdminHeader /> */}
        <main className="p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
